import React from 'react'
import { GridCell, Text, View } from 'oio-react'
import { Link, useParams, useRouteMatch } from 'react-router-dom'
import { initiativeUrl } from 'config/constants/urls'
import InitiativeListItemRow from 'src/sites/kits/Initiative/components/ListItemRowSmall'
import DiscussionListItemRow from 'src/sites/kits/Discussions/components/ListItemRowSmall'
import { useInitiativeList, useOrganization } from 'src/core/graphql/hooks'
import { useGlobalState } from 'src/sites/state'

const FollowingBlock = () => {
   const match = useRouteMatch()
   const { userId } = useParams()
   const { theme } = useGlobalState()

   const { organization } = useOrganization()
   const discussionInitiativeTypeIds = organization.initiativeTypes
      .filter(t => t.enabled && t.class === 'discussion')
      .map(t => t.id)

   const { initiativeList } = useInitiativeList({
      drafts: userId === 'me' ? 'include' : 'exclude',
      limit: 5,
      sortBy: 'dateLastUpdated',
      typeIds: discussionInitiativeTypeIds,
      userRelationshipFilter: {
         userId,
         hasElementType: 'subscribed'
      }
   })

   if (!initiativeList.items.length) {
      return null
   }

   return (
      <GridCell>
         <View
            width="100%"
            height="100%"
            borderRadius="3px">
            <View
               display="flex"
               justifyContent="space-between"
               padding="0px 0px 15px 0px">
               <Text size="3" weight="medium" color={theme.tmpContentTitleColor}>
                  Following
               </Text>
               <View flex="0 0 auto">
                  <Link to={`${match.url}/collection/following`}>
                     <Text color="#aaa" size="1.5">
                        See All
                     </Text>
                  </Link>
               </View>
            </View>
            {initiativeList.items.map((initiative) => {
               const ListItemRow = initiative.class === 'discussion'
                  ? DiscussionListItemRow
                  : InitiativeListItemRow

               return (
                  <ListItemRow
                     key={initiative.id}
                     addedBy={initiative.addedBy.fullName}
                     archived={initiative.archived}
                     coverUrl={initiative.coverMedia?.file.thumbnailUrlW480}
                     dateLastUpdated={initiative.dateLastUpdated}
                     discussionFormat={initiative.discussionFormat}
                     discussionIsClosed={initiative.discussionStatus?.closed}
                     hasUnreadEntries={initiative.thread.hasUnreadEntries}
                     linkTo={initiativeUrl(initiative)}
                     name={initiative.name}
                     numThreadEntries={initiative.thread.numEntries}
                     numViews={initiative.numViews}
                     pinned={initiative.pinned}
                     privacy={initiative.privacy}
                     slug={initiative.slug}
                     textColor={theme.tmpContentTitleColor}
                     typeSlug={initiative.type.slug}
                     borderStyle={`1px solid ${theme.tmpContentLineColor}`}
                  />
               )
            })}
         </View>
      </GridCell>
   )
}

export default FollowingBlock
